import { type MutableRefObject } from 'react';

function getCssGridColumnCount(element: HTMLElement): number {
  const computedStyle = window.getComputedStyle(element);
  const gridTemplateColumns = computedStyle.getPropertyValue('grid-template-columns');
  return gridTemplateColumns.split(' ').length;
}

export const getRowColumnCounts = (
  containerRef: MutableRefObject<HTMLDivElement | null>,
  index?: number,
): { row: number; column: number } | undefined => {
  const parentContainer = containerRef.current;
  if (!parentContainer || index === undefined) return undefined;
  const columnCount = getCssGridColumnCount(parentContainer);

  const row = Math.floor(index / columnCount) + 1;

  const column = (index % columnCount) + 1;

  return { row, column };
};
